var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefrigerator = function SvgRefrigerator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.098 14.498a.6.6 0 0 1-.6.6h-5a.6.6 0 1 1 0-1.2h5a.6.6 0 0 1 .6.6zm-.7-5v-5a.6.6 0 1 1 1.2 0v5a.6.6 0 1 1-1.2 0zm2.51 7.9h-9.82c-.266 0-.49-.183-.49-.4v-4.4h10.8v4.4c0 .221-.22.4-.492.4zm-9.819-14.8h9.818c.271 0 .491.18.491.4v8.4h-10.8v-8.4c0-.217.225-.4.491-.4zm9.818-1.2H5.09c-.932 0-1.69.718-1.69 1.6v14c0 .882.758 1.6 1.69 1.6h9.818c.932 0 1.691-.718 1.691-1.6v-14c0-.882-.759-1.6-1.69-1.6z",
    clipRule: "evenodd"
  })));
};
export default SvgRefrigerator;